<div class="sol-content">
  @for (block of blocks$(); track block.id) {
    @switch (block.type) {
      @case ('heading') {
        <div
          [id]="asHeading(block).anchorId"
          class="sol-content-heading sol-text-color-ink"
          [class]="headingClass(asHeading(block))"
        >
          <ng-container
            [ngTemplateOutlet]="inlineTemplate"
            [ngTemplateOutletContext]="{ segments: asHeading(block).segments }"
          />
        </div>
      }
      @case ('paragraph') {
        <div class="sol-content-paragraph sol-text-style-body sol-text-color-ink">
          <ng-container
            [ngTemplateOutlet]="inlineTemplate"
            [ngTemplateOutletContext]="{ segments: asParagraph(block).segments }"
          />
        </div>
      }
      @case ('quote') {
        <blockquote class="sol-content-quote sol-text-style-body sol-text-color-opacity-high">
          <ng-container
            [ngTemplateOutlet]="inlineTemplate"
            [ngTemplateOutletContext]="{ segments: asQuote(block).segments }"
          />
        </blockquote>
      }
      @case ('list') {
        <ng-container [ngTemplateOutlet]="listTemplate" [ngTemplateOutletContext]="{ list: asList(block) }" />
      }
      @case ('table') {
        <div class="sol-content-table">
          <sol-report-table [table]="tablesByBlockId$()[block.id]" />
        </div>
      }
      @case ('code') {
        <pre class="sol-content-code-block"><code>{{ asCodeBlock(block).code }}</code></pre>
      }
      @case ('image') {
        <div class="sol-content-image-block">
          <sol-image class="sol-content-image" [image]="asImageBlock(block).image" />
          @if (asImageBlock(block).title) {
            <div class="sol-content-image-title sol-text-style-body-small sol-text-color-opacity-high">
              {{ asImageBlock(block).title }}
            </div>
          }
        </div>
      }
      @case ('divider') {
        <div class="sol-content-divider" aria-hidden="true"></div>
      }
    }
  }
</div>

<ng-template #inlineTemplate let-segments="segments">
  @for (segment of segments; track segment.id) {
    @switch (segment.type) {
      @case ('text') {
        <span>{{ segment.text }}</span>
      }
      @case ('strong') {
        <span class="sol-text-style-body-bold sol-text-color-ink">
          <ng-container
            [ngTemplateOutlet]="inlineTemplate"
            [ngTemplateOutletContext]="{ segments: segment.segments }"
          />
        </span>
      }
      @case ('emphasis') {
        <span class="sol-content-inline-emphasis">
          <ng-container
            [ngTemplateOutlet]="inlineTemplate"
            [ngTemplateOutletContext]="{ segments: segment.segments }"
          />
        </span>
      }
      @case ('code') {
        <code class="sol-content-inline-code">{{ segment.text }}</code>
      }
      @case ('link') {
        <sol-button
          class="sol-content-inline-link"
          [type]="SolButtonType.link"
          [custom]="true"
          (click)="onLinkClick(asLink(segment), $event)"
          (auxclick)="onLinkAuxClick(asLink(segment))"
        >
          <ng-container
            [ngTemplateOutlet]="inlineTemplate"
            [ngTemplateOutletContext]="{ segments: asLink(segment).segments }"
          />
        </sol-button>
      }
      @case ('image') {
        <sol-image class="sol-content-inline-image" [image]="asImageInline(segment).image" />
      }
    }
  }
</ng-template>

<ng-template #listTemplate let-list="list">
  @if (list.ordered) {
    <ol class="sol-content-list sol-content-list-ordered">
      @for (item of list.items; track item.id) {
        <li class="sol-content-list-item sol-text-style-body sol-text-color-ink">
          <ng-container
            [ngTemplateOutlet]="inlineTemplate"
            [ngTemplateOutletContext]="{ segments: asListItem(item).segments }"
          />
          @if (asListItem(item).childList) {
            <ng-container
              [ngTemplateOutlet]="listTemplate"
              [ngTemplateOutletContext]="{ list: asListItem(item).childList }"
            />
          }
        </li>
      }
    </ol>
  } @else {
    <ul class="sol-content-list sol-content-list-unordered">
      @for (item of list.items; track item.id) {
        <li class="sol-content-list-item sol-text-style-body sol-text-color-ink">
          <ng-container
            [ngTemplateOutlet]="inlineTemplate"
            [ngTemplateOutletContext]="{ segments: asListItem(item).segments }"
          />
          @if (asListItem(item).childList) {
            <ng-container
              [ngTemplateOutlet]="listTemplate"
              [ngTemplateOutletContext]="{ list: asListItem(item).childList }"
            />
          }
        </li>
      }
    </ul>
  }
</ng-template>
